// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const EditTool = createSvgIcon(
  { All: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M22.4282 4.0556c.366.7363.5717 1.5663.5717 2.4444 0 4.0963-3.02 6.4691-7 5.5l-10 10s-2 2-4 0 0-4 0-4L12 8c-.9691-3.98 1.4038-7 5.5-7 .8781 0 1.7081.2058 2.4445.5717l-3.0556 3.095S15.6666 5.8889 15.6666 6.5c0 1.0125.8208 1.8333 1.8333 1.8333.6112 0 1.8334-1.2222 1.8334-1.2222l3.0949-3.0555z" /></React.Fragment>, },
  'default'
);
